import {Map, fromJS, List} from "immutable";

import {
    GET_QUOTES_SUCCESS,
    GET_QUOTES_REQUEST,
    GET_QUOTES_ERROR,

    GET_QUOTE_REQUEST,
    GET_QUOTE_SUCCESS,
    GET_QUOTE_ERROR,

    CREATE_QUOTE_REQUEST,
    CREATE_QUOTE_SUCCESS,
    CREATE_QUOTE_ERROR,

    UPDATE_QUOTE_REQUEST,
    UPDATE_QUOTE_SUCCESS,
    UPDATE_QUOTE_ERROR,

    CHANGE_STATUS_QUOTE_REQUEST,
    CHANGE_STATUS_QUOTE_SUCCESS,
    CHANGE_STATUS_QUOTE_ERROR,

    UPLOAD_QUOTE_FILES_REQUEST,
    UPLOAD_QUOTE_FILES_PROGRESS,
    UPLOAD_QUOTE_FILES_SUCCESS,
    UPLOAD_QUOTE_FILES_ERROR,

    DELETE_QUOTE_FILE_REQUEST,
    DELETE_QUOTE_FILE_SUCCESS,
    DELETE_QUOTE_FILE_ERROR,

    DELETE_QUOTE_REQUEST,
    DELETE_QUOTE_SUCCESS,
    DELETE_QUOTE_ERROR,

    CLEAN_QUOTES
} from '../actions/quotes';

const quotes = (state = Map({
  payload: List([]),
  isFetching: false,
    isUploading: false,
  error: false
}), action) => {
  let newState, updatedPayload, index, payload = state.get('payload');
  switch (action.type) {

      // Requests
      case GET_QUOTES_REQUEST:
      case GET_QUOTE_REQUEST:
      case CREATE_QUOTE_REQUEST:
      case UPDATE_QUOTE_REQUEST:
      case CHANGE_STATUS_QUOTE_REQUEST:
      case DELETE_QUOTE_FILE_REQUEST:
      case DELETE_QUOTE_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;
      case UPLOAD_QUOTE_FILES_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              isUploading: true,
              error: action.error,
              percent: 0
          });
          return newState;

      // Progress
      case UPLOAD_QUOTE_FILES_PROGRESS:
          newState = state.merge({
              percent: action.percent
          });
          return newState;

      // Success
      case GET_QUOTES_SUCCESS:
      case GET_QUOTE_SUCCESS:
      case CLEAN_QUOTES:
          newState = state.merge({
              payload: fromJS(action.payload),
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      case CREATE_QUOTE_SUCCESS:
          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              updatedPayload = payload.push(fromJS(action.payload));

              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(payload)) {
              updatedPayload = fromJS(action.payload);
          }

          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              created: action.created,
              payload: updatedPayload
          });
          return newState;

      case UPDATE_QUOTE_SUCCESS:
      case CHANGE_STATUS_QUOTE_SUCCESS:
      case UPLOAD_QUOTE_FILES_SUCCESS:
      case DELETE_QUOTE_FILE_SUCCESS:
          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              // Find the index of the project to be updated inside the List
              index = payload.findIndex(item => {
                  return item.get('_id') === action.payload._id;
              });
              // Update the payload list
              if (index !== -1) {
                  updatedPayload = payload.update(index, () => {
                      return fromJS(action.payload);
                  });
              }
              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(state.get('payload'))) {
              updatedPayload = fromJS(action.payload);
          }
          newState = state
              .merge({
                  isFetching: action.isFetching,
                  isUploading: false,
                  percent: 0,
                  error: action.error,
                  updated: action.updated,
                  payload: updatedPayload
              });
          return newState;
      case DELETE_QUOTE_SUCCESS:
          updatedPayload = payload.filter( workReport => {
              return workReport.get('_id') !== action.payload._id;
          });
          newState = state.merge({
              payload: updatedPayload,
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Errors
      case GET_QUOTES_ERROR:
      case GET_QUOTE_ERROR:
      case CREATE_QUOTE_ERROR:
      case UPDATE_QUOTE_ERROR:
      case CHANGE_STATUS_QUOTE_ERROR:
      case UPLOAD_QUOTE_FILES_ERROR:
      case DELETE_QUOTE_FILE_ERROR:
      case DELETE_QUOTE_ERROR:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              errorMessage: action.errorMessage
          });
          return newState;
      default:
          return state;
  }
};

export default quotes;



// WEBPACK FOOTER //
// ./src/reducers/quotes.js